export default "__VITE_ASSET__Cstma1bl__"